import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { PathResolveService } from './path-resolve.service';
import { UserApiService } from '../data-transfer/services/user-api-service';

export const ppwrAllowedGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const userApiService = inject(UserApiService);

  const organization = await firstValueFrom(userApiService.getOwnOrganization());
  if (organization.performPPWR) {
    return true;
  }

  router.navigate([PathResolveService.getCockpitPath()]);
  return false;
};
